<script setup>
defineProps({
  title: {
    type: String,
    required: true,
  },
  center: { type: Boolean },
})
</script>

<template>
  <div
    class="flex items-center"
    :class="{ 'justify-center': center, 'justify-between': !center }"
  >
    <h1 class="text-2xl">
      {{ title }}
    </h1>
    <slot></slot>
  </div>
</template>
